import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { LectureSeuleService } from "src/app/core/services/lecture-seule.service";

@Component({
	selector: "gm-button-primary",
	templateUrl: "./button-submit.component.html",
})
export class ButtonPrimaryComponent implements OnInit {
	@Output() clickBtn = new EventEmitter<any>();

	@Input() loading: boolean = false;
	@Input() label: string = "Publier";
	@Input() disabled: boolean = false;
	@Input() color: string = "primary";
	@Input() btnCta: string = "primary";
	@Input() icon: string = "add";
	@Input() hidden: boolean = false;
	@Input() title: string = "";
	/**
	 * Ces boutons déclenchent en général une écriture : ils disparaissent sur un
	 * écran en consultation seule. À passer à true pour les actions qui ne font
	 * que lire (filtrer, exporter, imprimer, prévisualiser).
	 */
	@Input() estConsultation: boolean = false;

	private lectureSeuleService = inject(LectureSeuleService);

	get class(): string {
		return `btn rounded-pill shadow-none fs-14 btn-${this.color} btn-cta-${this.btnCta}`;
	}
	get classLoading(): string {
		return `btn rounded-pill shadow-none fs-14 btn-${this.color} btn-cta-${this.btnCta} `;
	}
	get masque(): boolean {
		return !this.estConsultation && this.lectureSeuleService.isLectureSeule;
	}
	constructor() {}

	ngOnInit(): void {}
}
